import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { VaultGate } from "@/features/vault/components/vault-gate";
import { SharesPage } from "@/features/vault/components/shares-page";

/**
 * Secretos compartidos conmigo (sobres sellados a mi clave pública). Tras la
 * compuerta: abrirlos exige mi clave privada en memoria.
 */
function SharesRoutePage() {
  return (
    <VaultGate>
      <SharesPage />
    </VaultGate>
  );
}

export const sharesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/shares",
  component: SharesRoutePage,
});
